import "./styles.sass";
import FortuneWheelConditionsItem from "./FortuneWheelConditionsItem/FortuneWheelConditionsItem";

const data = [
  { title: "wheel.fortune.faq.how", description: "wheel.fortune.faq.how.desc" },
  { title: "wheel.fortune.faq.who", description: "wheel.fortune.faq.who.desc" },
  {
    title: "wheel.fortune.faq.often",
    description: "wheel.fortune.faq.often.desc",
  },
  {
    title: "wheel.fortune.faq.much",
    description: "wheel.fortune.faq.much.desc",
  },
  {
    title: "wheel.fortune.faq.what",
    description: "wheel.fortune.faq.what.desc",
  },
  {
    title: "wheel.fortune.faq.wager",
    description: "wheel.fortune.faq.wager.desc",
  },
];

const FortuneWheelConditionsModalContent: React.FC = () => {
  return (
    <div className="FortuneWheelModal__content">
      {data.map((item) => (
        <FortuneWheelConditionsItem
          key={item.title}
          title={item.title}
          description={item.description}
        />
      ))}
    </div>
  );
};

export default FortuneWheelConditionsModalContent;
